import { useState, useEffect } from "react";

const getCurrentTime = () => new Date().toLocaleTimeString();

const TimeBlocks = () => {
  const [time, setTime] = useState(getCurrentTime);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getCurrentTime());
    }, 1000);
    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  const timeSplit = time.split(":");
  const hours = timeSplit[0];
  const minutes = timeSplit[1];
  const seconds = timeSplit[2];

  if (!hours || !minutes || !seconds) {
    return;
  }

  const getTimeBlocksSection = digit => {
    digit = Number.parseInt(digit, 10);
    const numBlocks = 9;
    const timeBlocks = [];
    const availNums = [];
    for (let i = 1; i <= numBlocks; i++) {
      availNums.push(i);
    }
    const removeBlocks = numBlocks - digit;
    for (let i = 0; i < removeBlocks; i++) {
      // eslint-disable-next-line react-hooks/purity
      const randomIndex = Math.floor(Math.random() * availNums.length);
      availNums.splice(randomIndex, 1);
    }

    for (let i = 1; i <= numBlocks; i++) {
      if (availNums.includes(i)) {
        timeBlocks.push(<div className="timeBlockVisible" id={i} key={i}></div>);
      } else {
        timeBlocks.push(<div className="timeBlockHidden" id={i} key={i}></div>);
      }
    }

    return timeBlocks;
  };

  return (
    <div
      className="timeBlocks"
      onClick={() => {
        alert(`Blocks showing the current time (${time}) in a fun way`);
      }}
    >
      <div className="timeBlocksBox">
        <span className="block">{getTimeBlocksSection(hours[0])}</span>
      </div>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <div className="timeBlocksBox">
        <span className="block">{getTimeBlocksSection(hours[1])}</span>
      </div>
      <br />
      <br />
      <div className="timeBlocksBox">
        <span className="block">{getTimeBlocksSection(minutes[0])}</span>
      </div>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <div className="timeBlocksBox">
        <span className="block">{getTimeBlocksSection(minutes[1])}</span>
      </div>
      <br />
      <br />
      <div className="timeBlocksBox">
        <span className="block">{getTimeBlocksSection(seconds[0])}</span>
      </div>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <div className="timeBlocksBox">
        <span className="block">{getTimeBlocksSection(seconds[1])}</span>
      </div>
    </div>
  );
};

export default TimeBlocks;
